
/**
 * Statik hesaplama ve yardımcı fonksiyonlar Class'ı
 * @class Utils
 * @static
*/
var Utils = {}
window.Utils = {}
Utils.webglAvailable = function () {
    try {
        var canvas = document.createElement('canvas')
        return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')))
    } catch (e) {
        return false
    }
}

/**
 * Dereceden radyana çarpanı
 * @public
 * @memberof Utils
 * @property {float} TO_RAD
*/
const TO_RAD = Math.PI / 180
window.TO_RAD = TO_RAD

/**
 * Radyandan Dereceye çarpanı
 * @public
 * @memberof Utils
 * @property {float} TO_DEG
*/
const TO_DEG = 180 / Math.PI
window.TO_DEG = TO_DEG

/**
 * Touch device control
 * @public
 * @memberof Utils
 * @method isTouchDevice
 * @return {boolean}
 * @static
*/
Utils.isTouchDevice = function () {
    return ('ontouchstart' in window || window.DocumentTouch)
}

/**
 * Bilgisayar kontrolü.
 * @public
 * @memberof Utils
 * @method isComputer
 * @return {boolean}
 * @static
*/
Utils.isComputer = function () {
    if (typeof window.orientation !== 'undefined') {
        return false
    }
    return true
}

/**
 * @public
 * @memberof Utils
 * @method isMobileOrTablet
 * @return {boolean}
 * @static
*/
Utils.isMobileOrTablet = function () {
    /* eslint-disable */
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera)
    /* eslint-enable */
    return check
}

/**
 * Sort yardımcı fonksiyonu.  dist özelliğine göre karşılaştırma yapar.
 * @public
 * @memberof Utils
 * @method sortDist
 * @param {Object} a
 * @param {Object} b
 * @static
*/
Utils.sortDist = function (a, b) {
    return a.dist - b.dist
}

/**
 * Sort yardımcı fonksiyonu.  azimuth özelliğine göre karşılaştırma yapar.
 * @public
 * @memberof Utils
 * @method sortAzimuth
 * @param {Object} a
 * @param {Object} b
 * @static
*/
Utils.sortAzimuth = function (a, b) {
    return a.azimuth - b.azimuth
}

/**
 * Bearing algoritması
 * @public
 * @memberof Utils
 * @method bearing
 * @param {float} startLat
 * @param {float} startLon
 * @param {float} destLat
 * @param {float} destLon
 * @return {float}
 * @static
*/
Utils.bearing = function (startLat, startLon, destLat, destLon) {
    var phi1 = startLat * TO_RAD
    var phi2 = destLat * TO_RAD
    var cosPhi2 = Math.cos(phi2)
    var dLmd = (destLon - startLon) * TO_RAD
    var aci = Math.atan2(Math.sin(dLmd) * cosPhi2, Math.cos(phi1) * Math.sin(phi2) - Math.sin(phi1) * cosPhi2 * Math.cos(dLmd))
    return aci * TO_DEG
}

/**
 * Normal hesaplama
 * @public
 * @memberof Utils
 * @method GetNormal
 * @param {Vector} p1
 * @param {Vector} p2
 * @param {Vector} p3
 * @return {Vector}
 * @static
*/
Utils.GetNormal = function (p1, p2, p3) {
    var Ux = p2.x - p1.x
    var Uy = p2.y - p1.y
    var Uz = p2.z - p1.z

    var Vx = p3.x - p1.x
    var Vy = p3.y - p1.y
    var Vz = p3.z - p1.z

    var n = {}

    n.x = (Uy * Vz) - (Uz * Vy)
    n.y = (Uz * Vx) - (Ux * Vz)
    n.z = (Ux * Vy) - (Uy * Vx)

    return n
}

/**
* static method for WGS84 distance calculation. Return in meter
*@method heversine
*@static
*@deprecated use 'Utils.haversine'  this method is mistyped.
*@memberof Utils
**/
Utils.heversine = function (lat1, lat2, lon1, lon2) {
    return Utils.haversine(lat1, lat2, lon1, lon2)
}

/**
* static method for WGS84 distance calculation. Return in meter
* http://www.movable-type.co.uk/scripts/latlong.html
*@method heversine
*@static
*@memberof Utils
**/
Utils.haversine = function (lat1, lat2, lon1, lon2) {
    var R = 6371000 // metres
    var phi1 = lat1 * TO_RAD
    var phi2 = lat2 * TO_RAD
    var deltaphi = (lat2 - lat1) * TO_RAD
    var deltalamda = (lon2 - lon1) * TO_RAD
    var a = Math.sin(deltaphi / 2) * Math.sin(deltaphi / 2) + Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltalamda / 2) * Math.sin(deltalamda / 2)
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    return R * c
}

/**
 * String parsel
 * @public
 * @memberof Utils
 * @method ParseLabelString
 * @param {string} ltex
 * @param {GeomDataHolder} g
 * @return {string}
 * @static
*/
Utils.ParseLabelString = function (ltex, g) {
    if (ltex === undefined || !ltex) {
        return ''
    }

    var geomData = g.getCommonGeom()
    if (geomData === undefined) {
        console.error('undefined variable')
    }

    var textSeperator = ','

    var texts = ltex.split(',')

    var txt = ''
    for (var i = 0; i < texts.length; i++) {
        if (i > 0) {
            txt += textSeperator
        }

        if (texts[i].indexOf('FUNC>>') === 0) {
            var functionText = texts[i].replace('FUNC>>', '')
            if (typeof window[functionText] === 'function') {
                txt += window[functionText](g)
            } else {
                txt += 'Funcli'
            }
        } else {
            var postFix = ''
            var preFix = ''
            var rawTextAr = texts[i].split('|')

            if (rawTextAr.length > 1) {
                postFix = rawTextAr[1]
            }

            if (rawTextAr.length > 2) {
                preFix = rawTextAr[2]
            }

            var fieldName = rawTextAr[0]
            if (fieldName[0] === '#') {
                fieldName = fieldName.substr(1, fieldName.length - 1)
                fieldName = geomData.attributes[fieldName]
            }

            txt += preFix + fieldName + postFix
        }
    }

    return txt
}

/**
 * Güzergah algoritması.
 * http://www.movable-type.co.uk/scripts/latlong.html
 * @public
 * @memberof Utils
 * @method destinationPoint
 * @param {float} lat1
 * @param {float} lon1
 * @param {float} distance
 * @param {float} angle
 * @return {float}
 * @static
*/
Utils.destinationPoint = function (lat1, lon1, distance, angle) {
    var radius = 6371e3
    var δ = Number(distance) / radius // angular distance in radians
    var θ = Number(angle) * TO_RAD
    var φ1 = lat1 * TO_RAD
    var λ1 = lon1 * TO_RAD
    var φ2 = Math.asin(Math.sin(φ1) * Math.cos(δ) +
        Math.cos(φ1) * Math.sin(δ) * Math.cos(θ))
    var λ2 = λ1 + Math.atan2(Math.sin(θ) * Math.sin(δ) * Math.cos(φ1),
        Math.cos(δ) - Math.sin(φ1) * Math.sin(φ2))
    λ2 = (λ2 + 3 * Math.PI) % (2 * Math.PI) - Math.PI // normalise to -180..+180°
    return { lat: φ2 * TO_DEG, lon: λ2 * TO_DEG }
}

Utils.angleDifference = function (a, b) {
    return 180 - Math.abs(Math.abs(a - b) - 180)
}

/**
 * Vector cross products
 * @public
 * @memberof Utils
 * @method cross
 * @param {Vector} a
 * @param {Vector} b
 * @return {Vector}
 * @static
*/
Utils.cross = function (a, b) {
    var x = (a.y * b.z) - (a.z * b.y)
    var y = (a.z * b.x) - (a.x * b.z)
    var z = (a.x * b.y) - (a.y * b.x)
    return { x: x, y: y, z: z }
}

/**
 * Vector dot products
 * @public
 * @memberof Utils
 * @method dot
 * @param {Vector} u
 * @param {Vector} v
 * @return {Vector}
 * @static
*/
Utils.dot = function (u, v) {
    return u.x * v.x + u.y * v.y + u.z * v.z
}

Utils.norm2 = function (v) {
    return v.x * v.x + v.y * v.y + v.z * v.z
}

/**
 * Vector çarpımı
 * @public
 * @memberof Utils
 * @method vmul
 * @param {Vector} v1
 * @param {Vector} v2
 * @return {Vector}
 * @static
*/
Utils.vmul = function (v1, v2) {
    var x = v1.x * v2.x
    var y = v1.y * v2.y
    var z = v1.z * v2.z
    return { x: x, y: y, z: z }
}

/**
 * Heron algoritması
 * @public
 * @memberof Utils
 * @method heron
 * @param {float} a
 * @param {float} b
 * @param {float} c
 * @return {float}
 * @static
*/
Utils.heron = function (a, b, c) {
    var s = (a + b + c) / 2
    var sa = s - a
    var sb = s - b
    var sc = s - c
    var d = Math.sqrt(s * sa * sb * sc)
    return d
}

/**
 * Yazı texture oluşturucu
 * @public
 * @memberof Utils
 * @method createTextTexture
 * @static
*/
Utils.createTextTexture = function (message, borderColor) {
    var context = contextcontext
    if (!canvas) {
        canvas = document.createElement('canvas')
        canvas.id = 'textureA'
        context = canvas.getContext('2d')
        document.body.appendChild(canvas)
        canvas.style.position = 'absolute'
        canvas.style.top = '0px'
        canvas.style.left = '0px'
        contextcontext = context
    } else {
        canvas.style.display = 'block'
        context.clearRect(0, 0, canvas.clientWidth, canvas.clientHeight)
    }

    var fontSize = 120 / 2
    borderColor = borderColor || { r: 50, g: 50, b: 50, a: 1 }
    context.strokeStyle = 'rgba(' + borderColor.r + ',' + borderColor.g + ',' + borderColor.b + ',' + borderColor.a + ')'
    context.lineWidth = 4
    context.font = 'Bold ' + fontSize + 'px ' + ' Arial'
    context.fillStyle = 'rgba(255, 255,255, 0.4)'
    context.textAlign = 'center'
    context.strokeText(message, 1024 / 2, (128 - fontSize))
    context.fillText(message, 1024 / 2, (128 - fontSize))
    canvas.style.display = 'none'

    var texture = new THREE.Texture(contextcontext.getImageData(0, 0, 1024, 128))
    texture.needsUpdate = true

    return texture
}

/**
 * Yer için texture yardımcısı.
 * @public
 * @memberof Utils
 * @method createTextTextureForGround
 * @static
*/
var groundCanvas
Utils.createTextTextureForGround = function (message) {
    var context = contextcontext
    var canvas = groundCanvas
    if (!groundCanvas) {
        groundCanvas = document.createElement('canvas')
        groundCanvas.id = 'groundCanvas'
        context = groundCanvas.getContext('2d')
        document.body.appendChild(groundCanvas)
        groundCanvas.style.position = 'absolute'
        groundCanvas.style.top = '0px'
        groundCanvas.style.left = '0px'
        groundCanvas.width = 1024
        groundCanvas.height = 128
        groundCanvas.style.background = '#ff0000'
        contextcontext = context
        canvas = groundCanvas
    } else {
        groundCanvas.style.display = 'block'
        context.clearRect(0, 0, groundCanvas.clientWidth, groundCanvas.clientHeight)
    }

    // document.body.appendChild(groundCanvas);
    // groundCanvas.style.zIndex = 999999;
    var fontSize = 120 / 2
    // backgroundColor = backgroundColor ? backgroundColor : {r:209,g:209, b:209, a:.6};

    var borderColor = { r: 50, g: 50, b: 50, a: 1 }

    context.strokeStyle = 'rgba(' + borderColor.r + ',' + borderColor.g + ',' + borderColor.b + ',' + borderColor.a + ')'
    context.lineWidth = 4
    context.font = 'Bold ' + fontSize + 'px ' + ' Arial'
    var measure = context.measureText(message)
    var textWidth = measure.width
    var textHeight = fontSize * 1.6

    context.fillStyle = 'rgba(255, 255,255, 1)'
    // context.fillRect(0, 0, 1024, 128);

    context.textAlign = 'center'
    context.textBaseline = 'middle'
    context.strokeText(message, 1024 / 2, (128 / 2))
    context.fillText(message, 1024 / 2, (128 / 2))

    canvas.style.display = 'none'

    var texture = new THREE.Texture(contextcontext.getImageData(0, 0, 1024, 128))
    texture.needsUpdate = true

    return { texture: texture, textWidth: textWidth, fontHeight: textHeight }
}

/**
 * Sprite label çizim yardımcısı.
 * @public
 * @memberof Utils
 * @method makeTextSprite
 * @static
*/
var canvas
var contextcontext
Utils.makeTextSprite = function (sprite, message, fontSize, backgroundColor, borderColor, textColor, borderWidth, cornerRound) {
    var fontface = 'Arial'
    fontSize = (fontSize || 30) / 2
    var textHeight = fontSize * 1.6
    var borderThickness = borderWidth && borderWidth !== undefined ? borderWidth : 2
    borderColor = borderColor || { r: 111, g: 111, b: 111, a: 1 }
    backgroundColor = backgroundColor || { r: 209, g: 209, b: 209, a: 0.6 }
    textColor = textColor || { r: 0, g: 0, b: 0, a: 1 }
    cornerRound = cornerRound && cornerRound !== undefined ? cornerRound : 6
    var context = contextcontext

    var canvsSizeW = 2048
    var canvsSizeH = 2048
    if (!canvas) {
        canvas = document.createElement('canvas')
        canvas.id = 'textureA'
        context = canvas.getContext('2d')
        document.body.appendChild(canvas)
        canvas.style.position = 'absolute'
        canvas.style.top = '0px'
        canvas.style.left = '0px'
        canvas.width = canvsSizeW
        canvas.height = canvsSizeH
        contextcontext = context
    } else {
        canvas.style.display = 'block'
        context.clearRect(0, 0, canvsSizeW, canvsSizeH)
    }

    context.textBaseline = 'alphabetic'
    context.textAlign = 'start'
    // context.textAlign = "left";
    context.font = 'Bold ' + fontSize + 'px ' + fontface

    var metrics = context.measureText(message)
    var textWidth = metrics.width + 10

    context.fillStyle = 'rgba(' + backgroundColor.r + ',' + backgroundColor.g + ',' + backgroundColor.b + ',' + backgroundColor.a + ')'
    // border color
    context.strokeStyle = 'rgba(' + borderColor.r + ',' + borderColor.g + ',' + borderColor.b + ',' + borderColor.a + ')'

    context.lineWidth = borderThickness
    Utils.roundRect(context, borderThickness / 2, borderThickness / 2, textWidth + 5, fontSize * 1.4 + borderThickness, cornerRound)
    // 1.4 is extra height factor for text below baseline: g,j,p,q.

    // text color
    context.fillStyle = 'rgba(' + textColor.r + ', ' + textColor.g + ',' + textColor.b + ', ' + textColor.a + ')'
    context.fillText(message, borderThickness + 5, fontSize + borderThickness)
    canvas.style.display = 'none'
    var spriteMaterial
    if (!sprite) {
        var texture = new THREE.Texture(contextcontext.getImageData(0, 0, textWidth + 60, textHeight))
        texture.needsUpdate = true
        texture.generateMipmaps = false
        texture.minFilter = THREE.LinearFilter
        spriteMaterial = new THREE.SpriteMaterial({ map: texture, depthTest: false, depthWrite: false })
        var tSprite = new THREE.Sprite(spriteMaterial)
        tSprite.scale.set(textWidth, 50, 1.0)
        return tSprite
    } else {
        var mat = sprite.material
        var met = contextcontext.getImageData(0, 0, textWidth + 7, textHeight)
        var exImage = mat.map
        mat.map.image = met
        mat.map.needsUpdate = true
        mat.needsUpdate = true
        sprite.scale.set(textWidth, textHeight, 1.0)
        exImage.dispose()
    }
}

/**
 * yuvarlak köşeli kare çizici.
 * @public
 * @memberof Utils
 * @method roundRect
 * @param {CanvasContext} ctx
 * @param {float} x pozisyon X
 * @param {float} y pozisyon Y
 * @param {float} w Genişlik
 * @param {float} h Yükseklik
 * @param {float} r yuvarlaklık oranı
 * @static
*/
Utils.roundRect = function (ctx, x, y, w, h, r) {
    ctx.beginPath()
    ctx.moveTo(x + r, y)
    ctx.lineTo(x + w - r, y)
    ctx.quadraticCurveTo(x + w, y, x + w, y + r)
    ctx.lineTo(x + w, y + h - r)
    ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h)
    ctx.lineTo(x + r, y + h)
    ctx.quadraticCurveTo(x, y + h, x, y + h - r)
    ctx.lineTo(x, y + r)
    ctx.quadraticCurveTo(x, y, x + r, y)
    ctx.closePath()
    ctx.fill()
    ctx.stroke()
}

/**
 * URL için Strig merger
 * @public
 * @memberof Utils
 * @method mergeStringForUrl
 * @param {string} str1
 * @param {string} str2
 * @static
*/
Utils.mergeStringForUrl = function (str1, str2) {
    var origin1 = str1
    var i
    for (i = str1.length - 1; i >= 0; i--) {
        if (str1[i] !== '/') {
            origin1 = str1.substr(0, i + 1)
            break
        }
    }

    var origin2 = str2
    for (i = 0; i < str2.length; i++) {
        if (str2[i] !== '/') {
            origin2 = str2.substr(i, str2.length - i)
            break
        }
    }

    return origin1 + '/' + origin2
}

/**
 * Script yükleme fonksiyonu
 * @public
 * @memberof Utils
 * @method loadScript
 * @param {string} src
 * @param {function} callback
 * @static
*/
Utils.loadScript = function (src, callback) {
    var head = document.getElementsByTagName('head')[0]
    var script = document.createElement('script')
    var done = false
    script.setAttribute('src', src)
    script.setAttribute('type', 'text/javascript')
    script.setAttribute('charset', 'utf-8')
    script.onload = script.onreadstatechange = function () {
        if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
            done = true
            script.onload = script.onreadystatechange = null
            if (callback) {
                callback()
            }
        }
    }
    head.insertBefore(script, head.firstChild)
}

// var geographicToCartesian = function (center, point, camHegInPix, camHegInMet) {
//     const TO_RAD = Math.PI / 180

//     var lat = point.lat
//     var lon = point.lon
//     var alt = point.alt

//     var cLat = center.lat
//     var cLon = center.lon
//     // var cAlt = center.alt

//     // Azimuth
//     var phi1 = cLat * TO_RAD
//     var phi2 = lat * TO_RAD
//     var cosPhi2 = Math.cos(phi2)
//     var dLmd = (lon - cLon) * TO_RAD
//     var aci = Math.atan2(Math.sin(dLmd) * cosPhi2, Math.cos(phi1) * Math.sin(phi2) - Math.sin(phi1) * cosPhi2 * Math.cos(dLmd))
//     var azimuth = (aci * TO_DEG) % 360
//     var theta = (360 - azimuth) % 360
//     // Azimuth End

//     var R = 6371000 // metres
//     phi1 = cLat * TO_RAD
//     phi2 = lat * TO_RAD
//     var deltaphi = (lat - cLat) * TO_RAD
//     var deltalamda = (lon - cLon) * TO_RAD
//     var a = Math.sin(deltaphi / 2) * Math.sin(deltaphi / 2) + Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltalamda / 2) * Math.sin(deltalamda / 2)
//     var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
//     var dist = R * c

//     // var dist = Utils.heversine(cd.lat, lat, cd.lon, lon)
//     var hip = (dist * Math.abs(camHegInPix)) / camHegInMet
//     var rad = (360 - (theta + 90)) / 180 * Math.PI
//     var altPx = ((alt - cd.altitude) * Math.abs(camHegInPix)) / camHegInMet

//     var xx = hip * Math.cos(rad)
//     var zz = hip * Math.sin(rad)
//     var yy = altPx
//     return { x: xx, y: yy, z: zz }
// }

function setDef (value, def) {
    return value !== undefined ? value : def
}

Utils.setDef = setDef

export { Utils, TO_DEG, TO_RAD, setDef }
